<template>
    <div :class="standalone ? 'refund-standalone' : ''">
        <component :is="standalone ? 'div' : 'b-dropdown-form'" :style="standalone ? null : { width: '20rem' }">
            <b-form-select v-if="standalone" :options="typeOptions" v-model="type" size="sm" class="mt-0 mb-3">
                <template #first>
                    <b-form-select-option :value="null" disabled>Type</b-form-select-option>
                </template>
            </b-form-select>
            <b-select v-else :options="typeOptions" v-model="type" size="sm" class="mt-3">
                <template #first>
                    <b-form-select-option :value="null" disabled>Type</b-form-select-option>
                </template>
            </b-select>

            <b-input-group prepend="$" size="sm" :class="standalone ? 'mb-3' : 'mt-3'">
                <b-form-input type="number" v-model="amount" placeholder="Amount"></b-form-input>
            </b-input-group>

            <b-input-group prepend="Note" size="sm" :class="standalone ? 'mb-3' : 'mt-3'">
                <b-form-input v-model="note" placeholder="Note"></b-form-input>
            </b-input-group>

            <div class="text-right" :class="standalone ? 'mt-3 pt-2' : 'mt-3'">
                <b-button v-if="hasInitialValues" @click="deleteRefund()" size="sm" variant="warning" class="mr-2">Delete</b-button>
                <b-button :disabled="!hasValues" @click="doRefund()" size="sm" variant="primary">{{ hasInitialValues ? 'Update' : 'Add Refund' }}</b-button>
            </div>
        </component>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "Refund",
        props: {
            initialType: { type: String, default: null },
            initialAmount: { type: [Number, String], default: null },
            initialNote: { type: String, default: null },
            isExisting: { type: Boolean, default: false },
            standalone: { type: Boolean, default: false },
        },
        data() {
            return {
                type: this.initialType || null,
                amount: this.initialAmount ?? null,
                note: this.initialNote || null,
                typeOptions: [
                    'PayPal',
                    'Credit Card',
                    'Cash',
                    'Other',
                ]
            };
        },
        methods: {
            doRefund() {
                const refundObj = {
                    username: this.$auth.user.nickname,
                    amount: parseFloat(this.amount),
                    type: this.type,
                    note: this.note || undefined,
                    date: moment().toISOString(),
                };

                this.$emit('addRefund', refundObj);

                if (!this.hasInitialValues) {
                    this.amount = null;
                    this.type = null;
                    this.note = null;
                }
            },
            deleteRefund() {
                this.$emit('removeRefund');
            }
        },
        computed: {
            hasValues() {
                return this.type && this.amount != null && this.amount !== '';
            },
            hasInitialValues() {
                return this.isExisting || (this.initialType && (this.initialAmount != null && this.initialAmount !== ''));
            }
        }
    };
</script>

<style scoped>
.refund-standalone {
    min-width: 18rem;
}
</style>
